module.exports = __webpack_public_path__ + "static/yoox-pattern-f4ef3ef93d2ff9a853c10b4b15f5cd3d.jpg";